import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=1ecbcdea&scoped=true&"
import script from "./Resume.vue?vue&type=script&lang=js&"
export * from "./Resume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecbcdea",
  null
  
)

export default component.exports